<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    width="70%"
    :formErrors="formErrors"
    :loading="loading"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
        :modelNameSingular="modelNameSingular"
      />
    </template>
    
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      entry: null,
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function() {
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_NEW_CULTURE_QUERY,
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.entry = response.data.adminContext.culture;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    createServerEntry: function(end_product) {
      // console.log("CULTURE", end_product, this.entry.validations, this.deepFilterEntryWithAllowedFieldsForMutation(culture, this.entry.validations));
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: CREATE_END_PRODUCT_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(end_product, this.entry.validations)
          }
        })
        .then(response => {
          var errors = response.data.createEndProduct.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseNew.closeDialog();
            this.$emit("entry-created", response.data.createEndProduct.culture);
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    createEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.createServerEntry(this.entry);
        this.resetForm();
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_NEW_END_PRODUCT_QUERY = gql `
  {
    adminContext{
      endProduct {
        id
        description
        barcode
        brandId
        brand {
          name
        }
        unitId
        unit {
          name
        }        
        varietyId
        variety {
          id
          name
          title
        }
        validations
      }
    } 
    globalContext {
      allUnits {
        id
        name
      }
      allVarieties {
        id
        name
        title
      }
    }
    accountGlobalSharedContext {
      allBrandsOfItems {
        id
        name
      }
    }
  }
`;

const CREATE_END_PRODUCT_MUTATION = gql `
  mutation($input: EndProductCreateInputObject!) {
    createEndProduct(input: $input) {
      item {
        id
        name
        description
        barcode
        brandId
        brand {
          name
        }
        unitId
        unit {
          name
        }
      }
      errors
    }
  }
`;

</script>

<style scoped></style>
